export default __webpack_public_path__ + "static/media/DashboardBtn.7f390a84.svg";